import translations from './translations';

/**
 * Standalone translation function for use outside React components.
 * Reads current language from localStorage (same source as LanguageContext).
 * Supports variable interpolation: t('key', { n: 3 }) → replaces {n} in string.
 */
export const t = (key, vars = {}) => {
  const saved = localStorage.getItem('separatus_lang');
  let lang = 'de';
  if (saved && translations[saved]) {
    lang = saved;
  } else {
    const browserLang = navigator.language || navigator.userLanguage || '';
    lang = browserLang.startsWith('de') ? 'de' : 'en';
  }

  let text = translations[lang]?.[key] || translations['de']?.[key] || key;
  Object.entries(vars).forEach(([k, v]) => {
    text = text.replaceAll(`{${k}}`, v);
  });
  return text;
};
